/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState = [];

const oimStatusUpdateSlice = createSlice({
    name: 'oimStatusUpdateForm',
    initialState: initialState,
    reducers: {
        setFormData: (state, action) => {
            return action.payload;
        },
        setStatusUpdate: (state, action) => {
            return state.map((item) => {
                if (item.id === action.payload.id) {
                    return action.payload;
                }
                return item;
            });
        },
        addStatus: (state, action) => {
            addUniqueById(state, action.payload);
        },
        deleteStatus: (state, action) => {
            const idToDelete = action.payload;

            if (Array.isArray(idToDelete)) {
                return state.filter((status) => !idToDelete.includes(status.id));
            } else {
                return state.filter((status) => status.id !== idToDelete);
            }
        },
    },
});

export const { setFormData, setStatusUpdate, addStatus, deleteStatus } = oimStatusUpdateSlice.actions;
export default oimStatusUpdateSlice.reducer;
